var _defs, _path, _polygon, _polygon2, _polygon3, _path2, _circle, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownUploadDocuments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00c853;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M197.8,49.64,175.16,26.22a14,14,0,0,0-10-4.26H64.93A19.34,19.34,0,0,0,45.59,41.3v70.43H66.38V44h96.19l17,17.55a8.36,8.36,0,0,1,2.34,5.8v44.39h20.81v-50A17.39,17.39,0,0,0,197.8,49.64ZM75,192.55H66.38V130.88H45.59v64.34a19.35,19.35,0,0,0,19.35,19.36H96.27L78,195.7Zm106.91-61.67v61.67H151.5v22h31.84a19.35,19.35,0,0,0,19.35-19.35V130.88Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "162 180.4 143.05 180.4 143.05 226.37 129.13 226.37 129.13 146.47 129.16 146.43 162 180.4"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "119.42 146.43 119.42 226.34 119.4 226.37 107.13 213.68 87.78 193.68 86.55 192.41 105.51 192.41 105.51 146.43 119.42 146.43"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "66.39 43.98 124.06 101.66 176.04 49.67 164.35 37.97 123.34 78.98 80.11 35.76 66.39 35.76 66.39 43.98"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M222.52,95.82H28.88a25.48,25.48,0,1,0,0,51H222.52a25.48,25.48,0,0,0,0-51ZM19.3,121.3a9.59,9.59,0,0,1,9.58-9.57H222.52a9.57,9.57,0,0,1,0,19.14H28.88A9.59,9.59,0,0,1,19.3,121.3Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 209.12,
    cy: 120.85,
    r: 5.38
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 192.11,
    cy: 120.85,
    r: 5.38
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownUploadDocuments);
export default __webpack_public_path__ + "static/media/downUploadDocuments.945ea5d6.svg";
export { ForwardRef as ReactComponent };